import { VENDOR_REQUEST_LIST } from "./type";
import { VENDOR_ONBOARDED_LIST,VENDOR_PAYMENT_ADD,PO_DETAIL ,PAYMENT_LIST,VENDOR_PAYMENT_DETAIL,PAYMENT_REQUEST_LIST,VENDOR_PAYMENT_REQUEST_DETAIL,FILTER_LIST,INVOICE_REQUEST_LIST,INVOICE_REQUEST_DETAILS,REQUEST_INVOICE_REQUEST_DETAILS,VENDOR_DEPARTMENT, GET_VENDOR_DEPARTMENTS, ADD_VENDOR_ADVANCES} from "./type";

const initalState = {
  vendorRequestList: {},
  vendorDepartment: {},
  vendorOnboardedList:{},
  vendorPaymentAdd:{},
  poDetail:{},
  paymentList:{},
  payment_detail:{},
  payment_request_list:{},
  payment_request_detail:{},
  list_filter:{},
  invoiceRequestList:{},
  invoiceRequestDetail:{},
  requestInvoiceRequestDetail:{},
  vendorDepartmentList:{}
};

const vendorPortalReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FILTER_LIST:
      return{
        ...state,
        list_filter: payload,
      }
    case VENDOR_REQUEST_LIST:
      return {
        ...state,
        vendorRequestList: payload,
      };
    case  VENDOR_DEPARTMENT:
      return {
        ...state,
        vendorDepartment: payload,
      };
    case VENDOR_ONBOARDED_LIST:
    return {
      ...state,
      vendorOnboardedList: payload,
    };
    case VENDOR_PAYMENT_ADD:
    return {
      ...state,
      vendorPaymentAdd: payload,
    };
    case PO_DETAIL:
    return {
      ...state,
      poDetail: payload,
    };
    case PAYMENT_LIST:
      return {
        ...state,
        paymentList: payload,
      };
    case VENDOR_PAYMENT_DETAIL:
      return {
        ...state,
        payment_detail: payload,
      };
    case PAYMENT_REQUEST_LIST:
      return {
        ...state,
        payment_request_list: payload,
      };
    case VENDOR_PAYMENT_REQUEST_DETAIL:
      return {
        ...state,
        payment_request_detail: payload,
      };
    case INVOICE_REQUEST_LIST:
      return {
        ...state,
        invoiceRequestList: payload,
      };
    case INVOICE_REQUEST_DETAILS:
      return {
        ...state,
        invoiceRequestDetail: payload,
      };
    case REQUEST_INVOICE_REQUEST_DETAILS:
      return {
        ...state,
        requestInvoiceRequestDetail: payload,
      };
    case GET_VENDOR_DEPARTMENTS:
      return {
        ...state,
        vendorDepartmentList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default vendorPortalReducer;
